
import React, { useState } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useSiteSettings } from '../../siteSettings';
import './style.css'

const Welcome = (props) => {
  const {
    className
  } = props;

  const [modal, setModal] = useState(false);
  const settings = useSiteSettings();

  const toggle = () => setModal(!modal);

  return (

    <div  className={`welcome-area ${props.welcome}`}>
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="welcome-content">
                        <h2>Bienvenue pour notre grand jour</h2>
                        <p>Nous sommes heureux de vous inviter à partager cette journée exceptionnelle. Votre présence rendra notre célébration encore plus belle et inoubliable.</p>
                        <div className="btn"><AnchorLink href='#rsvp'>Confirmer ma présence</AnchorLink></div>
                        {settings.mapEmbedLink && <Button className="btn" onClick={toggle}>Voir le lieu</Button>}
                        {settings.mapEmbedLink && <Modal isOpen={modal} toggle={toggle} className={className}>
                            <ModalHeader toggle={toggle}>Lieu de célébration</ModalHeader>
                            <ModalBody>
                                <div className="location-map">
                                    <iframe title="Carte du lieu" src={settings.mapEmbedLink} />
                                </div>
                            </ModalBody>
                        </Modal>}
                    </div>
                </div>
            </div>
        </div>
    </div>

  );
}

export default Welcome;
